import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import i18n from './modules/i18n';
import cart from './modules/cart';
import customer from './modules/customer';
import request from './modules/request';
import layer from './modules/layer';
import wishlist from './modules/wishlist';
import sharedEnv from './modules/sharedEnv';
import user from './modules/user';
export default (() => new Vuex.Store({
  actions,
  getters,
  modules: {
    i18n,
    cart,
    customer,
    request,
    layer,
    wishlist,
    sharedEnv,
    user
  }
}));